<template>
  <div ><button class="returnBtn" @click="back">返回</button></div>
   <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>

<div class="container font mt-1" >
         <Form @submit="save" :validation-schema="isUpdate?updateSchema:schema">
           <div class="d-flex justify-content-center flex-column align-items-center full-width" style="position: relative;" >

            <grid-loader :loading="isSubmit" :color="spinnerColor" class="middle_abs"></grid-loader>
         
            <div class="title d-flex flex-column align-items-center justify-content-center" >
              <span v-if="isUpdate">修改选题</span>
              <span v-else>新增账号</span>
              <div class="validText">强烈建议使用新注册的小红书账号</div>
            </div>

            <div class="full-width" >
             <div>
                <div class="mt-1 textbox_label">
             手机号<span class="important">*</span>：</div>
             <div class="d-flex justify-content">
                  <Field type="text" name="phone_no" id="phone_no" 
                                 class="textBox" 
                                 v-model="phone_no"
                                 @blur='check_phone'
                                 placeholder="请输入你的小红书登录手机号" 
                 />
             </div>
             <div v-if="phone_existed" class="textbox textbox_label error-message">此手机号已经注册</div>
             <div><ErrorMessage name="region" class="textbox textbox_label error-message"/></div> 
             <div><ErrorMessage name="phone_no" class="textbox_label error-message"/></div> 
             </div>

             

              
            
             <div v-if="tem_accounts!=null && tem_accounts.length>0" >
        <div class="mt-1 textbox_label">
             直接使用已配置好的赛道：</div>
             <div class="text-secondary">Tips: 如果自己配置，不要选择任何赛道</div>
            <div class="mb-1 d-flex justify-content">
              <div v-for="(n,index) in tem_accounts" :key="index">
                <div :class="n==selected_tem?'acc_box mr-1 selectedPageBox':'acc_box mr-1 normalPage'" @click="selectAcc(n)">
                  {{ n.topic }}
                </div>
                
              </div>

          </div> 

          <div v-if="selected_tem!=null" class="d-flex align-items-center">
            <span>选择数据的排序方式：</span>
            <Field type="text" name="sort" id="sort" 
                                 class="textBox" 
                                 v-model="sort"
                                 style="width:100px"
                               
                                 placeholder="请输入排序方式，空代表同选择赛道" 
                 />
             </div>

        </div>
             <div >
              <div v-if="selected_tem==null || isUpdate">
              <div class="mt-1 textbox_label">
             发送数量<span class="important">*</span>：</div>
              <div class="text-secondary">Tips: 可以配置每天发送几篇或者每周发送几篇</div>
             <div class="d-flex justify-content">
              <span>每</span>
                  <Field as="select" name="count_type" id="count_type" 
                                 v-model="count_type">
                                <option value="day" selected>天</option>
                                <option value="week">周</option>
                                <option value="month">月</option>
                                </Field>

                   <Field as="select" name="sent_counts" id="sent_counts"  class="ml-1"
                                 v-model="sent_counts">
                                <option value="1">1</option>
                                <option value="2" >2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                  </Field>
                  <span>篇笔记</span>
             </div>

              </div>
            <div class="mt-1" v-if="selected_tem==null">

               <div class="textbox_label">
                选题关键字<span class="important">*</span>:
               </div>
              
               <div class="text-secondary">Tips: 可以在小红书中输入选定的关键字，查看结果是否一致</div>
               <div>
               <Field 
               type="text" 
               name="keyword" 
               id="keyword"
               class="textBox" 
               v-model="keyword"
               placeholder="请输入选题的关键字" 
               />
             </div>
             <div>
               <ErrorMessage name="keyword" class="textbox_label error-message"/>
             </div>
            </div>

            <div class="mt-1" v-if="selected_tem==null">
              <button @click="showPopup=true" type="button" class="btn normalBtn">选择笔记配图</button>

              <div class="d-flex justify-content mt-1">
                <div v-if="selected_cover!=undefined">
                  <div>封面</div>
                  <div v-if="selected_cover!=undefined">
                    <img :src="selected_cover['default_img']" class="img">
                  </div>
                </div>
                <div class="ml-2" v-if="selected_content!=undefined">
                 
                  <div>正文</div>
                  <img :src="selected_content['default_img']" class="img">
                </div>
              </div>
              </div>

        </div>
           </div> 
             <div class="error-message mt-1">
                                     {{  errors}}
                                 </div>
             <div class="mt-1 mb-1">
               <button type="submit" v-if="!isSubmit&&!phone_existed" class="blueBtn submitBtn">提交</button>
               <button v-else class="blueBtn submitBtn btnDiabled">提交</button>
             </div>
           </div>
         </Form>
 
 
        </div>
        <PopupWindow v-model:isShow="showPopup" >
                <TemplateChoosen @set_template="addTemplate"></TemplateChoosen>
        </PopupWindow>
 </template>
 
 <script>
 import axios from 'axios';
 import { Form, Field,ErrorMessage } from 'vee-validate';
 import * as yup from 'yup';
 import GridLoader from 'vue-spinner/src/GridLoader.vue'
 import TemplateChoosen from './TemplateChoosen.vue';
 import PopupWindow from './PopupWindow.vue';
 
 
 export default {
   data(){
     const schema = yup.object({
      // region:yup.number('请输入数字区号').required('请输入区号').default(86),
       phone_no: yup.string().required("请输入手机号码"),
      //  settings: yup.string().required("请输入账号设置"),
      //  keyword: yup.string().required("请输入关键字")
     });

     const updateSchema = yup.object({
      // settings: yup.string().required("请输入账号设置"),
      // keyword: yup.string().required("请输入关键字")
     });
     return {
      isLoading:false,
       ifAdd:false,
       day:1,
      
       isValid: true,
       schema,
       errors:'',
       isSubmit:false,
       spinnerColor:"#262626",
       updateSchema,
       keywords:[],
       setting_types:0,
       account_settings:[],
       selected_setts:null,
       showPopup:false,
       selected_cover:null,
       selected_content:null,
       accountId:undefined,
       isUpdate:false,
       accountInfo:null,
       phone_no:null,
       keyword:null,
       isempty_user:false,
       phone_existed:false,
       tem_accounts:null,
       selected_tem:null,
       sent_counts:2,
       count_type:'day',
       sort:null,
       template_acc_id:null,
       user_id:null,
       role:0
     }
   },
   components: {
     Form,
     Field,
     ErrorMessage,
     GridLoader,
     TemplateChoosen,
     PopupWindow
   },
    setup(){
     
      var token=localStorage.getItem('sessionToken')
      axios.defaults.headers.common['X-Parse-Session-Token'] = token
 
   },
 

   mounted(){ 

    var empty=this.$route.query.empty
    if(empty==undefined)
    {
      this.isempty_user=false
    }
    else
    {
      this.isempty_user=true
    }

    this.user_id=this.$route.params.user_id;
     this.role=localStorage.getItem('role');
    
    console.log(this.$router)


this.selected_setts=this.account_settings[this.setting_types]

this.accountId = this.$route.params.id;
this.user_id=this.$route.params.user_id;
if(this.accountId!=undefined)
{
  this.isUpdate=true;
  this.getInfo()
  
 
}
else{
this.selected_tem=null
      this.get_template_accs()
}
      
  },
   methods:{
    selectAcc(acc){
      if(this.selected_tem!=acc)
    {
      this.selected_tem=acc
    }
    else
    {
      this.selected_tem=null
    }
      
    },
    async check_phone(){     
      try{
        
        console.log('blur')
        this.phone_existed=false;

        const response = await axios.get(this.domain+'xhs/check_phone_exist?phone='+this.phone_no);

        var data=response.data
        if(data.status=='Suc')
        {
          this.phone_existed=data.exists
        }
        else
        {
            console.error(data)
            
        }
      }
      catch(error)
      {
          console.error(data)
      }
     
    
    },

     async get_template_accs(){     
      try{
        
        if(this.isLoading==false)
        {

          this.isLoading=true
        }
        const response = await axios.get(this.domain+'xhs/get_template_accounts');

        var data=response.data
        if(data.status=='Suc')
        {
          this.tem_accounts=data.accs
          console.log(this.tem_accounts)
          for(let tem of this.tem_accounts)
        {
          if(tem.account_id==this.template_acc_id)
          {
            this.selected_tem=tem
          }
        }
        }
        else
        {
            console.error(data)
            this.errors=data
        }
      }
      catch(error)
      {
          console.error(data)
           this.errors=data
      }
      finally
      {
        this.isLoading=false
        console.log(this.isLoading)
      }
     
    
    },

    back(){
      if(this.isempty_user)
      {
        this.$router.push('/index/user/account?empty_back=true')
      }
      else
      {
        this.$router.go(-1)
      }
        
      },
    setSettingTypes(t){
      this.setting_types=t
      this.selected_setts=this.account_settings[this.setting_types]
    },
    save(values){
      console.log(this.isUpdate)
        if (this.isUpdate)
        {
            this.updateConfig(values)
        }
        else
        {
            this.createAccounts(values);
        }
    },
    addTemplate(data){
      this.showPopup=false;
      this.selected_cover=data['cover']
      this.selected_content=data['content']

    },


  async getInfo(){
    try{
      this.isLoading=true;
     
      const response = await axios.get(this.domain+'xhs/get_account_settings?account_id='+this.accountId);

      var data=response.data
      if(data.status=='Suc')
      {
         this.accountInfo=data.info
         if(this.accountInfo!=undefined)
         {
          console.log(this.accountInfo)
          this.template_acc_id=this.accountInfo.template_acc
          this.phone_no=this.accountInfo.phone_no
          this.keyword=this.accountInfo.keyword
          this.sent_counts=this.accountInfo.sent_counts
          this.count_type=this.accountInfo.count_type
          this.selected_setts=this.accountInfo.character_settings
          console.log(this.sent_counts)
          this.get_template_accs()

          if(this.accountInfo.template_settings!=undefined)
          {
            if(this.accountInfo.template_settings.length==2)
            {
              this.selected_cover=this.accountInfo.template_settings[0]
              this.selected_content=this.accountInfo.template_settings[1]

            }
            else if(this.accountInfo.template_settings.length==1)
            {
              this.selected_content=this.accountInfo.template_settings[0]
            }
          }
         }
      }
      else
      {
          console.error(data)
          this.errors=data['msg']
      }
    }
    catch(error)
    {
        console.error(error)
        this.errors=error.msg
    }
  },



    async updateConfig(values){
    try{
      console.log('save')
      this.isLoading=true;
      if(this.selected_tem==null&& this.selected_cover==undefined&&this.selected_content==undefined)
           {
            this.errors='请选择文案配图'
            return
           }
            this.isSubmit=true;
            var content_id=null
            if (this.selected_content!=null)
           {
                content_id=this.selected_content.objectId
           }
           
           var linked_content=false
           if(this.selected_cover!=null&&this.selected_cover.linked_content!=undefined)
           {
            content_id=this.selected_cover.linked_content
            linked_content=true
           }
      const response = await axios.post(this.domain+'xhs/save_config',
      {
             'phone_no':values.phone_no,
              'keyword':values.keyword,
              'cover':this.selected_cover!=null?this.selected_cover.objectId:null,
              'content':content_id,
              'linked_content':linked_content,
              'account_id':this.accountId,
              'count_type':this.count_type,
              'day_count':this.sent_counts,
            'selected_acc':this.selected_tem==null?null:this.selected_tem.account_id,
            'sort':this.sort}
      );

      var data=response.data
      if(data.status=='Suc')
      {
        this.$router.push('/index/user/account')
      }
      else
      {
          console.error(data)
          this.errors=data['msg']
          
      }
    }
    catch(error)
    {
        console.error(error)
        this.errors=error.msg
    }
    finally{
      this.isSubmit=false
      this.isLoading=false
    }
  },

  replacedText(text) {
      return text.replace(/、|，|\s/g, ',');
    },

     async createAccounts(values){
         try{
           this.isSubmit=true;
           if(this.selected_tem==null && this.selected_cover==undefined&&this.selected_content==undefined)
           {
            this.errors='请选择文案配图'
            return
           }

            var content_id=null
           if(this.selected_content!=null)
           {
                content_id=this.selected_content.objectId
           }
           
           var linked_content=false
           if(this.selected_cover!=null&&this.selected_cover.linked_content!=undefined)
           {
              content_id=this.selected_cover.linked_content
              linked_content=true
           }
           const response = await axios.post(this.domain+'xhs/set_accounts',{
             'phone_no':values.phone_no,
              'keyword':values.keyword,
              'user_id':this.user_id,
              // 'settings':values.settings,
              'cover':this.selected_cover!=null?this.selected_cover.objectId:null,
              'content':content_id,
              'linked_content':linked_content,
              'count_type':this.count_type,
              'day_count':this.sent_counts,
            'selected_acc':this.selected_tem==null?null:this.selected_tem.account_id,
          'sort':this.sort});
 
           var data=response.data
           if(data.status=='Suc')
           {
              
              //  this.$emit('add_account_suc', results);
               this.$router.push('/qr/'+data['account'])
               
               
             
           }
           else
           {
             this.errors=data['msg']
               console.error(data)
           }
         }
         catch(error)
         {
           this.errors=error.msg;
             console.error(data)
         }
         finally
         {
           this.isSubmit=false;
         }
     },
 
 
     },
    
   
 };
 </script>
 <style scoped>

 .acc_box{
  padding:10px;
  border-radius: 5px;
  cursor: pointer;
 }
.bk{
  background-image: linear-gradient(to right bottom, #d8cbd3, #d7c6d6, #d2c2da, #c8bfe0, #bbbde6, #bcc2ea, #bdc6ed, #becbf1, #d1d7f4, #e2e4f7, #f2f1fb, #ffffff);
}
.left_box{
  background-color: #EF856D;
  border-radius: 0.125rem 0.125rem 0.125rem 0;
  width:max-content;
}
 .error-message{
  color:red
}
.right_box{
  background-color: #ffffff;
  border-radius: 0.125rem 0.125rem 0.125rem 0;
  width:max-content;
}

.textBox{
  width:100%;
  height:0.6rem;
  border:0.0125rem solid #4c4c4c;
  border-radius:0.125rem;
}

.textArea{
  width:100%;
  height:5rem;
  border:0.0125rem solid #4c4c4c;
  border-radius:0.125rem;
}
input:focus {
    outline: none;
}
.img{
    width: 2rem;
  }

  .important{
    color: red;
  }
 </style>
 
 
 